import { render } from "./Base.vue?vue&type=template&id=2429cfc5&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"

import "./Base.vue?vue&type=style&index=0&id=2429cfc5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2429cfc5"

export default script